/**
 * In this file use to contains all API calls
 **/
import axios from "axios";

/*Declare the API BaseUrl*/
const BaseUrl = process.env.REACT_APP_SERVERURL + "api";

/**
 * To handle api request
 **/
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    var loader = document.getElementsByClassName("loading-container")[0];
    loader.style.display = "block";
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (error) => {
    var loader = document.getElementsByClassName("loading-container")[0];
    loader.style.display = "none";
    Promise.reject(error);
  }
);

/**
 * To handle api response
 **/
axios.interceptors.response.use(
  (response) => {
    var loader = document.getElementsByClassName("loading-container")[0];
    loader.style.display = "none";
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    var loader = document.getElementsByClassName("loading-container")[0];
    loader.style.display = "none";
    return Promise.reject(error);
  }
);

/** 
   * This function call Account Login API 
   * @data pass username,password,passwordEPK,and verified keyword in Object format
    username pass login User email or mobile Number
    password pass login user password
    passwordEPK pass login user passwordEPK 
    verified pass login User Account verified status
   **/
const login = (data) => {
  return axios
    .post(`${BaseUrl}/account/login`, data)
    .then(function (response) {
      if (response.data?.accessToken) {
        localStorage.setItem("token", response.data.accessToken);
      }
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
   * This function call Account Login API 
   * @data pass username,password,passwordEPK,and verified keyword in Object format
    username pass login User email or mobile Number
    password pass login user password
    passwordEPK pass login user passwordEPK 
    verified pass login User Account verified status
   **/
const adminLogin = (data) => {
  return axios
    .post(`${BaseUrl}/account/admin/login`, data)
    .then(function (response) {
      if (response.data?.accessToken) {
        localStorage.setItem("token", response.data.accessToken);
      }
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API is used to Find User LoggedIn or Not
 **/
const isLoggedIn = () => {
  return axios
    .post(`${BaseUrl}/account/isLoggedIn`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function call Forgot Password API
  * @data pass username and verified keyword in Object format
    username pass User email or mobile Number	
    verified pass User Account verified status
  **/
const forgotPassword = (data) => {
  return axios
    .put(`${BaseUrl}/account/forgot-password`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function call Resend OTP API
  * @data pass user keyword in Object format
    user pass the user uuid
  **/

const resendOTP = (data) => {
  return axios
    .post(`${BaseUrl}/account/resendotp`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function call Verify OTP API
  * @data pass otp,user keyword in Object format
    otp pass the user enter otp value
    user pass the user uuid
  **/
const verifyOTP = (data) => {
  return axios
    .post(`${BaseUrl}/account/verifyotp`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * Tis function used to Create Password for user login
  * @data pass password,passwordEPK and user keywords in Object format
    password pass the user entered password in encrypt format
    passwordEPK pass the user passwordEPK value
    user pass the user uuid
  **/
const createPassword = (data) => {
  return axios
    .post(`${BaseUrl}/account/create-password`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function used To get user Profile details
 **/
const getProfile = () => {
  return axios
    .get(`${BaseUrl}/account/profile`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function used to Get all hospital,parent,phsician id and name details
  * @data pass list keyword in Object formt
    list pass needed list name in array format like {list:['hospital','parent','phsician']}
  **/
const getUsersList = (data) => {
  return axios
    .post(`${BaseUrl}/admin/users/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function used To update physician details and mapping details
 * @data pass physicianInfo,parentInfo and hospitalInfo keywords in Object format
 **/
const updatePhysician = (data) => {
  return axios
    .post(`${BaseUrl}/account/physician/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This uploadNewPhoto API used to change user profile image
 * @id pass the user uuid value
 * @data pass the binary format uploaded image in Form Data format
 **/
const uploadNewPhoto = (id, data) => {
  return axios
    .put(
      id
        ? `${BaseUrl}/account/upload-attachment?id=${id}`
        : `${BaseUrl}/account/upload-attachment`,
      data
    )
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This uploadChatAttachment API used to save the attachment in backend public folder and create a unique name for the file
 * @data pass the binary format uploaded chat attachment in From Data format
 **/
const uploadChatAttachment = (data) => {
  return axios
    .put(`${BaseUrl}/account/upload/chat/attachment`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get Particular Member Development details
 * @params pass the Particular Member id in Object format {id:'MemberId'}
 **/
const getMemberDevelopment = (params) => {
  const query = new URLSearchParams(params).toString();

  return axios
    .get(`${BaseUrl}/account/member/development/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get Particular Member Vaccination details
 * @params pass the Particular Member id in Object format like {id:'MemberId'}
 **/
const getMemberVaccination = (params) => {
  const query = new URLSearchParams(params).toString();
  return axios
    .get(`${BaseUrl}/account/member/vaccination/list?${query}`)
    .then(function (response) {
      // Handle filter duplicate vaccination filter when app previously posted vaccine same time submit/ offline flow so we filter chart to remove same vaccination with different dates shown in chart bug
      const uniqueItems = Object.values(
        response.data.items.reduce((acc, curr) => {
          const key = `${curr.vaccination}_${curr.type}_${curr.dose}_${curr.member}`;
          const currCreatedAt = new Date(curr.createdAt);
          const existingCreatedAt = new Date(acc[key]?.createdAt || 0);
          // Only update if no entry yet or current is newer
          if (!acc[key] || currCreatedAt > existingCreatedAt) {
            acc[key] = curr;
            console.log(`Updated key ${key} with createdAt: ${currCreatedAt.toISOString()}`);
          } else {
            console.log(`Skipped older entry for key ${key} with createdAt: ${currCreatedAt.toISOString()}`);
          }
          return acc;
        }, {})
      );
      response.data.items = uniqueItems;
      response.data.count = uniqueItems.length;      
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physicain mapped parent details list
 * @params pass the page and limit keywords in Object format like {page:'1',limit:'10'}
 **/
const parentList = (params) => {
  const query = new URLSearchParams(params).toString();
  return axios
    .get(`${BaseUrl}/physician/parent-list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To create TWILIO call token,socket's room name
 * @params pass the receiver keywords in Object format like {receiver:receiverId}
 **/
const makeCall = (params) => {
  return axios
    .post(`${BaseUrl}/account/make-call`, params)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To reject the incoming calls
 * @params pass the roomName keywords in Object format like {roomName:'roome name'}
 **/
const rejectCall = (params) => {
  return axios
    .post(`${BaseUrl}/account/reject-call`, params)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To answer the incoming calls
 * @params pass the roomName keywords in Object format like {roomName:'roome name'}
 **/
const answerCall = (params) => {
  return axios
    .post(`${BaseUrl}/account/answer-call`, params)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get Particular user chat history details
 * @id pass the participants uuid
 * @params pass the page,limit and participants keywords in Object format like
 **/
const getChatHistory = (id, params) => {
  const query = new URLSearchParams(params).toString();
  return axios
    .get(`${BaseUrl}/account/chat/message/${id}?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physician Notifications,appointment and message counts
 **/
const getNotificationCountList = () => {
  return axios
    .get(`${BaseUrl}/account/notification/counts`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get mapped contact list User details
 **/
const getchatContactList = () => {
  return axios
    .get(`${BaseUrl}/account/chat/contactlist`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * To Update the password
  * @data pass currentPassword,password and passwordEPK keywords in Object format
    currentPassword pass the current password in encrypt formt
    password pass the user entered password in encrypt format
    passwordEPK pass the user passwordEPK value
  **/
const updatePassword = (data) => {
  return axios
    .put(`${BaseUrl}/account/updatepassword`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To list family members based on the physician mapped parents
 * @data pass page,limi,age_range,clinics keywords in Object format
 * page pass the page Number
 * limit pass the limit what you need
 * age_range pass this value if you need to fliter particular age_range members list like {age_range:['0','1']) need to pass the age_range masterIds in array
 * clinics pass this value if you need to fliter particular clinics members list like {clinics:['uuid']) need to pass the clinics uuid in array
 **/
const listFamilyMember = (data) => {
  return axios
    .post(`${BaseUrl}/account/children/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

const listParentMember = (data) => {
  return axios
    .post(`${BaseUrl}/hospital-admin/parent/children/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physician mapped parent's members development details list
 * @data pass page and limit keywords in Object format
 **/
const listDevelopmentMember = (data) => {
  return axios
    .post(`${BaseUrl}/physician/development/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physician mapped parent's members medical issues details list
 * @data pass page and limit keywords in Object format
 **/
const listMedicalIssues = (data) => {
  return axios
    .post(`${BaseUrl}/physician/medical-issue/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get particular member's medical issues list
  * @data pass id,limit and page keywords in Object format
     id pass the Particular Member id
     limit pass the limit value
     page pass the page value
  **/
const listMemberMedicalIssues = (data) => {
  return axios
    .post(`${BaseUrl}/account/member/medical-issue/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physician mapped parent's members vaccination details list
 * @data pass page and limit keywords in Object format
 **/
const listVaccinationMember = (data) => {
  return axios
    .post(`${BaseUrl}/physician/vaccination/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get physician mapped clinics details list
 **/
const getPhysicainClinics = () => {
  return axios
    .get(`${BaseUrl}/physician/clinic/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get member Profile details based on the MemberId
 * @id pass the MemberId
 **/
const getMemberProfile = (id) => {
  return axios
    .get(`${BaseUrl}/account/family-member/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get Particular member measurement list
  * @data pass page,limit and id keywords in Object format
      page pass page value
    limit pass limit value
    id pass MemberId
  **/
const listMemberMeasurement = (data) => {
  return axios
    .get(`${BaseUrl}/account/member/measurement/list`, { params: data })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get Particular member medical issue list
  * @data pass page,limit and id keywords in Object format
      page pass page value
    limit pass limit value
    id pass MemberId
  **/
const listMemberMedicalIssue = (data) => {
  return axios
    .post(`${BaseUrl}/account/member/medical-issue/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To Delete the chat message
 * @id pass the chat message recordId
 **/
const deleteChatMessage = (id) => {
  return axios
    .put(`${BaseUrl}/account/chat/delete/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To search data from chatGPT
  * @data pass conversation and message keywords in Object format
      conversation pass prevoius conversation details
    message pass the current typed message details
  **/
const chatbotSearch = (data) => {
  return axios
    .post(`${BaseUrl}/account/chatbot/search`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get medication List for medical report
  * @data pass page,limit and id keywords in Object format
      page pass the page Number
    limit pass the limit value
    id pass the medical-issue recordId
  **/
const listMedication = (data) => {
  return axios
    .get(`${BaseUrl}/account/medication/list`, { params: data })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To create Analytics details
  * @data pass analyticsData keywords in Object format
     analyticsData pass OSVersion,appPlatform,appVersion,deviceType,member,operation,screenEndTime,screenStartTime,type,webBrowserType,webBrowserVersion details
  **/
const createAnalytics = (data) => {
  return axios
    .post(`${BaseUrl}/account/analytics/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get Notification list details
 * @params pass page and limit keywords in Object format
 **/
const getNotification = (params) => {
  const query = new URLSearchParams(params).toString();

  return axios
    .get(`${BaseUrl}/account/notification/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To Delete the Notification
 * @id pass the particular Notification recordId
 **/
const deleteNotification = (id) => {
  return axios
    .put(`${BaseUrl}/account/notification/delete/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To View the Notification
 * @id pass the particular Notification recordId
 **/
const viewNotification = (id) => {
  return axios
    .put(`${BaseUrl}/account/notification/view/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
  * This API used to get Member appointment get Api
  * @params pass page,limit and member keywords in Object format
     page pass the page count
     limit pass the limit of the record you need
     member pass the MemberId
  **/
const getMemberAppointment = (params) => {
  const query = new URLSearchParams(params).toString();

  return axios
    .get(`${BaseUrl}/physician/member/appointment/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To Update the appointment
 * @data pass the date,time,id,member,notes,,physician,reason,created_by keywords in Object format
 **/
const updateAppointment = (data) => {
  return axios
    .put(`${BaseUrl}/account/appointment/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To Delete the appointment
 * @id pass the appointment recordId
 **/
const deleteAppointment = (id, payload) => {
  return axios
    .put(`${BaseUrl}/account/appointment/delete/${id}`, payload) // Include the payload
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get the Particular appointment Details
 * @id pass the Particular appointment id
 **/
const getAppointment = (id) => {
  return axios
    .get(`${BaseUrl}/account/appointment/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get the unread chat notfication details
 **/
const getChatNotificationMessage = () => {
  return axios
    .get(`${BaseUrl}/account/chat/popup`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get appointment calender list details
  * @date pass sort,startDate and endDate keywords in Object format
     sort pass the fliter keyword like 'all','past','upcoming' any one each time
     startDate pass the calender start Date in UTC format
     endDate pass the calender end Date in UTC format
  **/
const getAppointmentCalendarList = (data) => {
  return axios
    .get(`${BaseUrl}/physician/appointment-calendar/list`, { params: data })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This API used To get Particular Member vitals list
  * @data pass page,limit,id and category keywords in Object format
     page pass the page Number
     limit pass the limit value
     id pass the MemberId
     category pass the vitals category masterId
  **/
const listMemberVitals = (data) => {
  return axios
    .get(`${BaseUrl}/account/vitals/list`, { params: data })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get master vaccination list
 **/
const masterVaccination = () => {
  return axios
    .get(`${BaseUrl}/account/master/vaccination/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get master development list
 **/
const masterDevelopment = () => {
  return axios
    .get(`${BaseUrl}/account/master/development/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To create Diagnosis details for particular medical-issue
 * @data pass diagnosis,recorded_date,notes,treatment,medication,follow_up,follow_up_date
 * @diagnosis - required field and pass the diagnosis name
 * @recorded_date - required field and pass the diagnosis recorded_date
 * @notes - required field and pass the notes
 * @treatment - required field and pass the treatment in string
 * @medication - required field and pass the medication details
 * @follow_up - required field and pass the boolean value
 * @follow_up_date - required field when follow_up is true otherwise not required
 **/
const createDiagnosis = (data) => {
  return axios
    .post(`${BaseUrl}/physician/diagnosis/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** This function is used to physician signup or register
 * @ data - pass the physicain details
 * @first_name - required field and pass the physician first_name
 * @last_name - required field and pass the physician last_name
 * @email - required field and should be in correct physician email format
 * @mobileNumber - required field and pass the physician mobileNumber
 * @specialist - required field and pass the physician specialist
 * @department - required field and pass the physician department
 * @city - required field and pass the physician city
 * @state - required field and pass the physician state
 * @gender - required field and pass the physician gender
 * @zipcode - required field and pass the physician zipcode
 **/
const physicianSignup = (data) => {
  return axios
    .post(`${BaseUrl}/account/physician/signup`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** This function is used to physician can request demo access
 * @ data - pass the physicain details
 * @first_name - required field and pass the physician first_name
 * @last_name - required field and pass the physician last_name
 * @email - required field and should be in correct physician email format
 * @mobileNumber - required field and pass the physician mobileNumber
 * @clinic_name - required field and pass the physician clinic_name
 * @message - required field and pass the physician message
 **/
const requestDemo = (data) => {
  return axios
    .post(`${BaseUrl}/account/physician/request-demo`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Get Admin Dashboard details
 **/
const getAdminDashboard = () => {
  return axios
    .get(`${BaseUrl}/admin/dashboard`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function is used to Get Parent details List API
  * @data - pass the search,sort,page and limit
     page - Pass the page value, default value is 0 
     limit - Pass the limit value, default value is 10 
     search - Search by parent name 
     sort - Pass the "added,a-z" 
  **/
const parentsList = (data) => {
  return axios
    .post(`${BaseUrl}/admin/parent/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Delete Parent API
 * @id - pass the parent id
 **/
const deleteParent = (id) => {
  //return axios.put(`${BaseUrl}/admin/parent/delete/`+id)
  return axios
    .delete(`${BaseUrl}/account/delete/login/` + id)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to list parent analytics history
 * @data - pass the id,page and limit
 * id - pass the parent id
 * page - Pass the page value, default value is 0
 * limit - Pass the limit value, default value is 10
 **/
const listAnalytics = (data) => {
  return axios
    .get(`${BaseUrl}/admin/analytics/list`, { params: data })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Create Parent API
 * @data - pass the Parent details in Object format
 **/
const createParent = (data) => {
  return axios
    .post(`${BaseUrl}/admin/parent/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};


/**
 * This function is used to Create Parent and Child API
 * @data - pass the Parent details in Object format
**/
const createParentAndAddMember = (data) => {
  return axios
    .post(`${BaseUrl}/hospital-admin/parent/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Create Parent and Child API
 * @data - pass the Parent details in Object format
**/

const updateParentAndUpdateMember = (data) => {
  return axios
    .put(`${BaseUrl}/hospital-admin/parent/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Create Parent and Child API
 * @data - pass the Parent details in Object format
**/

// const childrenList = (data) => {
//   return axios
//     .post(`${BaseUrl}/hospital-admin/parent/childrenList`, data)
//     .then(function (response) {
//       return response;
//     })
//     .catch(function (error) {
//       return error.response;
//     });
// };

const getParentDetails = (id) => {
  return axios
    .post(`${BaseUrl}/hospital-admin/parent/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Get Parent details API
 * @id - pass the parent id
 **/
const getParent = (id) => {
  return axios
    .get(`${BaseUrl}/admin/parent/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Update Parent details API
 * @data - pass the Parent Info, Physician Info and Hospital Info in Object format
 **/
const updateParent = (data) => {
  return axios
    .put(`${BaseUrl}/admin/parent/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to get Organization member list
 **/
const organizationMembers = () => {
  return axios
    .get(`${BaseUrl}/admin/organization`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to get Organization member list
 **/
const physicianMembers = () => {
  return axios
    .get(`${BaseUrl}/admin/physician/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Delete Physician API
 * @data - pass the physician id
 **/
const deletePhysicianList = (data) => {
  //return axios.put(`${BaseUrl}/admin/physician-delete`, data)
  return axios
    .delete(`${BaseUrl}/account/delete/login/` + data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function is used to Get Physician details List API
  * @data - pass the search,sort,page and limit
     page - Pass the page value, default value is 0 
     limit - Pass the limit value, default value is 10 
     search - Search by physician name 
     sort - Pass the "added,a-z" 
  **/
const physicianList = (data) => {
  return axios
    .post(`${BaseUrl}/admin/physician/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used Organization Mapping from physician
 * @data - pass the physicianInfo,parentInfo and hospitalInfo in Object format
 **/
const physicianMapping = (data) => {
  return axios
    .post(`${BaseUrl}/admin/physician/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Get Physician details API
 * @id - pass the Physician id
 **/
const getPhysician = (id) => {
  return axios
    .get(`${BaseUrl}/admin/physician/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Create Physician API
 * @data - pass the Physician details in Object format
 **/
const createPhysician = (data) => {
  return axios
    .post(`${BaseUrl}/admin/physician/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Delete Hospital List API
 * @data - pass the hospital id
 **/
const deleteHospitalList = (data) => {
  return axios
    .put(`${BaseUrl}/admin/organization-delete`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
  * This function is used to Get Organization List API
  * @data - pass the search,sort,page and limit
     page - Pass the page value, default value is 0 
     limit - Pass the limit value, default value is 10 
     search - Search by hospital name 
     sort - Pass the "added,a-z" 
  **/
const organizationList = (data) => {
  return axios
    .post(`${BaseUrl}/admin/organization/list`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Create Organization API
 * @data - pass the Organization details in Object format
 **/
const createOrganization = (data) => {
  return axios
    .post(`${BaseUrl}/admin/organization/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Get Organization API
 * @data - pass the Organization id
 **/
const getOrganization = (id) => {
  return axios
    .get(`${BaseUrl}/admin/organization/${id}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Update Organization API
 * @data - pass the Organization Info, Physician Info and Parent Info in Object format
 **/
const updateOrganization = (data) => {
  return axios
    .put(`${BaseUrl}/admin/organization/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to update admin profile API
 * @data - pass the admin details in object format
 **/
const updateProfile = (data) => {
  return axios
    .put(`${BaseUrl}/account/profile/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
  * This API used to get Member Diagnosis details
  * @params pass page,limit and id keywords in Object format
     page pass the page count
     limit pass the limit of the record you need
     id pass the medical-issue id
  **/
const getMemberDiagnosis = (params) => {
  const query = new URLSearchParams(params).toString();

  return axios
    .get(`${BaseUrl}/account/diagnosis/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get master measurement list
 **/
const masterMeasurementAges = () => {
  return axios
    .get(`${BaseUrl}/account/master/measurement/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To post measurements data
 **/
const createMeasurement = (data) => {
  return axios
    .post(`${BaseUrl}/account/measurement/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To post medical issue data
 **/
const createMedicalIssue = (data) => {
  return axios.post(`${BaseUrl}/account/medical-issue/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To create development
 **/
const createDevelopment = (data) => {
  return axios.post(`${BaseUrl}/account/development/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};


/**
* This API used To create vaccination
**/
const createVaccination = (data) => {
  return axios.post(`${BaseUrl}/account/vaccination/create`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To get master measurement list
 **/
const getChildList = () => {
  return axios
    .get(`${BaseUrl}/admin/child/list`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This function is used to Get Admin Dashboard details
 **/
const getHospitalAdminDashboard = () => {
  return axios
    .get(`${BaseUrl}/hospital-admin/dashboard`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
* This function is used to Get Appointment Booked Details for a physician based on work schedule data [days, startTime, endTime and outofoffice]
**/
const getBookedAppointmentDetails = (data) => {
    return axios.post(`${BaseUrl}/account/appointment/check/isbooked`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API used To Choose he language preference
 **/
const updateLanguagePreference = (data) => {
  return axios.put(`${BaseUrl}/account/language/update`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/**
 * This API is used to create device details for the physician login
 **/
const createDeviceDetails = (data) => {
  return axios
    .post(`${BaseUrl}/account/create/device/details`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};


/**
 * This API used To Choose The PRESCRIPTION TEMPLATE
 **/
const updatePrescriptionTemplate = (data) => {
  return axios.put(`${BaseUrl}/account/update-prescription-template`, data)
      .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** This API is used ti check the mobile number uniqness in hospital */
const checkHospitalMobileNumber = (data) => {
  return axios
    .post(`${BaseUrl}/admin/organization/check-mobile`, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    }
  );
};

/** 
* This function is used to Get Physician member upcoming vaccination details List API
* @data - pass the search,sort,page and limit
    page - Pass the page value, default value is 0 
    limit - Pass the limit value, default value is 10 
    search - Search by physician name 
    sort - Pass the "added,a-z" 
**/
const upcomingVaccinationList = (params) => {
  const query = new URLSearchParams(params).toString();
  return axios
    .get(`${BaseUrl}/account/member/upcoming/vaccination/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

/** 
* This function is used to Get Physician member upcoming vaccination details List API
* @data - pass the search,sort,page and limit
    page - Pass the page value, default value is 0 
    limit - Pass the limit value, default value is 10 
    search - Search by physician name 
    sort - Pass the "added,a-z" 
**/
const missedVaccinationList = (params) => {
  const query = new URLSearchParams(params).toString();
  return axios
    .get(`${BaseUrl}/account/member/missed/vaccination/list?${query}`)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.response;
    });
};

const ApiService = {
  listParentMember,
  adminLogin,
  login,
  isLoggedIn,
  forgotPassword,
  resendOTP,
  verifyOTP,
  createPassword,
  getProfile,
  getUsersList,
  updatePhysician,
  uploadNewPhoto,
  parentList,
  makeCall,
  rejectCall,
  answerCall,
  getChatHistory,
  getNotificationCountList,
  getchatContactList,
  updatePassword,
  listFamilyMember,
  listDevelopmentMember,
  listMedicalIssues,
  listMemberMedicalIssues,
  listVaccinationMember,
  getPhysicainClinics,
  getMemberProfile,
  listMemberMeasurement,
  listMemberMedicalIssue,
  getMemberVaccination,
  getMemberDevelopment,
  uploadChatAttachment,
  deleteChatMessage,
  chatbotSearch,
  listMedication,
  createAnalytics,
  getNotification,
  deleteNotification,
  viewNotification,
  getMemberAppointment,
  updateAppointment,
  deleteAppointment,
  getAppointment,
  getChatNotificationMessage,
  getAppointmentCalendarList,
  listMemberVitals,
  masterVaccination,
  masterDevelopment,
  createDiagnosis,
  physicianSignup,
  getAdminDashboard,
  parentsList,
  deleteParent,
  listAnalytics,
  createParent,
  getParent,
  updateParent,
  organizationMembers,
  physicianList,
  deletePhysicianList,
  physicianMapping,
  getPhysician,
  createPhysician,
  deleteHospitalList,
  organizationList,
  createOrganization,
  getOrganization,
  updateOrganization,
  updateProfile,
  getMemberDiagnosis,
  requestDemo,
  physicianMembers,
  masterMeasurementAges,
  createMeasurement,
  createMedicalIssue,
  createDevelopment,
  createVaccination,
  updateParentAndUpdateMember,
  getParentDetails,
  createParentAndAddMember,
  getChildList,
  getHospitalAdminDashboard,
  getBookedAppointmentDetails,
  updateLanguagePreference,
  createDeviceDetails,
  updatePrescriptionTemplate,
  upcomingVaccinationList,
  missedVaccinationList,
  checkHospitalMobileNumber
};

export default ApiService;
